import React from 'react';

const Hero: React.FC = () => {
  return (
    <section 
      id="home" 
      className="relative bg-cover bg-center text-white" 
      // Updated to use a new background image from the assets folder.
      // User should place 'new-homepage-hero-background.jpg' in 'public/assets/'
      // or change this path to their desired homepage background image.
      style={{ backgroundImage: "url('/purchased-on-premises-labels-banner.jpg')" }}
    >
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-48 max-w-7xl flex flex-col items-center text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          Boost Your Beverage Sales
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl mb-8 max-w-3xl">
          With Our Premium 'Purchased on Premises' Labels<br/> for Golf Courses
        </p>
        <div>
          <a
            href="#benefits"
            className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-3 px-8 md:py-4 md:px-10 rounded-lg text-lg md:text-xl transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;